import { useInitData } from './useInitData'

export function useAppAvailable() {
  const { availableSections } = useInitData()

  return Object.values(availableSections).some(Boolean)
}
